<template>
  <div>
    <v-card>
      <v-card-title> {{ model.Id == "" ? "Add Education History" : "Edit Education History" }}</v-card-title>
      <v-card-text>
        <v-form ref="frmRegister" v-model="valid" lazy-validation class="form-inputs">
          <v-row>
            <v-col cols="12">
              <span class="f-body-1">Course</span>
            </v-col>
            <v-col md="4" cols="12">
              <TextField
                :readonly="isHiringmanager"
                dense
                :rules="[validations.required]"
                outlined
                placeholder="Course Name"
                v-model="model.University"
              />
            </v-col>
            <v-col md="4" cols="12">
              <AutoCompleteField
                :readonly="isHiringmanager"
                :rules="[validations.required]"
                dense
                outlined
                :items="educationStatuses"
                placeholder="Degree ( Level )"
                v-model="model.Degree"
              />
            </v-col>
            <v-col md="4" cols="12">
              <AutoCompleteField
                :readonly="isHiringmanager"
                :rules="[validations.required]"
                dense
                outlined
                :items="studyFields"
                placeholder="Field Of Study"
                v-model="model.StudyField"
              />
            </v-col>
            <v-col cols="12">
              <span class="f-body-1">Dates</span>
            </v-col>
            <v-col md="4" cols="12">
              <DateInputField
                :readonly="isHiringmanager"
                first-day-of-week="1"
                v-model="model.StartDate"
                hide-actions
                placeholder="Start Date"
                prepend-icon=""
              />
            </v-col>
            <v-col md="4" cols="12">
              <DateInputField
                :readonly="isHiringmanager"
                first-day-of-week="1"
                v-model="model.EndDate"
                hide-actions
                placeholder="End date"
                prepend-icon=""
              />
            </v-col>
            <v-col md="4" class="pt-8 align-self-center">
              <v-switch :readonly="isHiringmanager" v-model="model.StillStudying" label="Currently Studying?" />
            </v-col>
            <v-col cols="12">
              <span class="f-body-1">Description</span>
            </v-col>
            <v-col cols="12">
              <TextAreaField :readonly="isHiringmanager" v-model="model.Description" placeholder="What did you learn?" />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions v-if="!isAfterSignUp">
        <v-col md="12" class="text-right">
          <v-btn v-if="!isHiringmanager" class="mr-5 secondary_btn" @click="cancel()" :loading="loading" prepend-icon="mdi-cancel"> Cancel</v-btn>
          <v-btn v-if="!isHiringmanager" class="primary_btn" @click="save()" :loading="loading" prepend-icon="mdi-check">
            {{ model.Id == "" ? "Add" : "Save" }}</v-btn
          >
        </v-col>
      </v-card-actions>
      <v-card-actions v-else class="justify-end">
        <v-btn v-if="!isHiringmanager" class="secondary_btn" @click="cancel()" :loading="loading" prepend-icon="mdi-cancel"> Cancel</v-btn>
        <v-btn v-if="!isHiringmanager" class="primary_btn" @click="save()" :loading="loading" prepend-icon="mdi-check">{{
          model.Id == "" ? "Add Education" : "Save"
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { Profile } from "../../../definitions/config";
import { EducationStatuses, StudyFields } from "../../../definitions/constants";
import validations from "../../../utils/validations";
import AutoCompleteField from "../../Fields/AutoCompleteField.vue";
import TextField from "../../Fields/TextField.vue";
import DateInputField from "../../Fields/DateInputField.vue";

export default defineComponent({
  props: ["editingItem", "addLoading", "gettingEducation", "isAfterSignUp", "isHiringmanager"],
  components: {
    AutoCompleteField,
    TextField,
    DateInputField,
  },
  data() {
    return {
      validations,
      employmentTypes: Profile.Members.EmploymentTypes,
      locationTypes: Profile.Members.LocationTypes,
      educationStatuses: EducationStatuses,
      studyFields: StudyFields,
      isgettingEducation: false,
      endDatePickerMenu: false,
      startDatePickerMenu: false,
      loading: false,
      valid: true,
      startMenu: false,
      endMenu: false,
      model: {
        StillStudying: false,
        Id: "",
        StartDate: null as Date | null,
        University: null as string | null,
        Degree: null as string | null,
        StudyField: null as string | null,
        EndDate: null as Date | null,
        Description: null as string | null,
      },
    };
  },
  mounted() {
    if (this.editingItem && this.editingItem.Id) {
      this.model = { ...this.editingItem };
    }
  },
  methods: {
    cancel(): void {
      this.$emit("cancelEditing");
    },
    async save(): Promise<void> {
      const isValid = (await (this.$refs.frmRegister as any).validate()).valid;
      if (isValid) {
        var item = { ...this.model };

        this.$emit("saved", {
          model: this.model,
          callbackMethod: () => {
            this.resetForm();
          },
        });
      } else if (!this.isgettingEducation) {
        var el = document.querySelector("#educationTab .v-messages.error--text:first-of-type");
        this.$emit("scrollToElement", el);
      } else if (this.isgettingEducation) {
        {
          this.$emit("saved");
        }
      }
    },
    resetForm() {
      this.model = {
        StillStudying: false,
        Id: "",
        StartDate: null as Date | null,
        University: null,
        Degree: null,
        StudyField: null,
        EndDate: null as Date | null,
        Description: null,
      };
      (this.$refs.frmRegister as any).reset();
    },
  },
  watch: {
    gettingEducation(newVal) {
      this.isgettingEducation = newVal;
      if (newVal) {
        this.save();
      }
    },
    "model.StillStudying": {
      handler() {
        if (this.model.StillStudying) {
          this.model.EndDate = null;
        }
      },
    },
    addLoading(newVal) {
      this.loading = newVal;
    },
  },
});
</script>
